module.exports = __webpack_public_path__ + "static/media/coupe.c5d49983.svg";